import { render, staticRenderFns } from "./exitpopup.vue?vue&type=template&id=5925aca0&scoped=true"
import script from "./exitpopup.vue?vue&type=script&lang=js"
export * from "./exitpopup.vue?vue&type=script&lang=js"
import style0 from "./exitpopup.vue?vue&type=style&index=0&id=5925aca0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5925aca0",
  null
  
)

export default component.exports